<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormTextareaInput } from '~/composables/useForm'

const props = defineProps<{
  data: FormTextareaInput
}>()

const { dt } = useDirectusTranslation()

const validation = computed(() => {
  return [
    props.data.required ? 'required' : null,
  ].join('|')
})
</script>

<template>
<FormKitLazyProvider config-file="true">

  <div>
    <FormKit
      :id="props.data.key"
      type="textarea"
      :name="props.data.key"
      :label="dt(props.data.translations)?.label"
      :placeholder="dt(props.data.translations)?.placeholder"
      :validation="validation"
    />
  </div>

</FormKitLazyProvider>
</template>

<style>

</style>
